











































import AppBarLanguageSwitcher from '@/components/AppBarLanguageSwitcher.vue'
import TenderService from '@/services/tender'
import { defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  name: 'CommissionerTokenIndex',
  components: { AppBarLanguageSwitcher },
  data: function (): {
    loading: boolean
    token: string
    tokenStatus: string
  } {
    const token = 'token' in this.$route.params && this.$route.params.token
    if (!token) {
      throw new Error('Token is missing required route param id')
    }
    return {
      token,
      loading: true,
      tokenStatus: '',
    }
  },
  setup() {
    const innerHeight = ref(window.innerHeight)

    window.addEventListener('resize', () => {
      innerHeight.value = window.innerHeight
    })

    return {
      innerHeight,
    }
  },
  methods: {
    async fetchTokenStatus(): Promise<void> {
      try {
        await TenderService.fetchCommissionerToken(this.token)
        this.tokenStatus = 'SUCCESS'
        setTimeout(() => {
          this.loading = false
        }, 500)
      } catch (error) {
        if (error.response.data.statusCode === 400) {
          this.tokenStatus = 'ALREADY_SIGNED'
          setTimeout(() => {
            this.loading = false
          }, 500)
        } else if (error.response.data.statusCode === 422) {
          this.tokenStatus = 'WRONG_STATUS'
          setTimeout(() => {
            this.loading = false
          }, 500)
        } else {
          this.tokenStatus = 'ERROR'
          setTimeout(() => {
            this.loading = false
          }, 500)
        }
      }
    },
  },
  mounted() {
    this.fetchTokenStatus()
  },
})
